import React from 'react';
import { Euro, Clock, CheckCircle, CreditCard, Download, Filter, ChevronDown } from 'lucide-react';
export function HostBillingPage() {
  const transactions = [{
    id: 1,
    date: '09 Feb 2026',
    desc: 'Pulizia post check-out',
    provider: 'Sofia Bianchi',
    amount: '€85',
    status: 'paid'
  }, {
    id: 2,
    date: '08 Feb 2026',
    desc: 'Sanificazione completa',
    provider: 'Marco R.',
    amount: '€120',
    status: 'processing'
  }, {
    id: 3,
    date: '07 Feb 2026',
    desc: 'Pulizia ordinaria',
    provider: 'Lucia M.',
    amount: '€75',
    status: 'paid'
  }, {
    id: 4,
    date: '05 Feb 2026',
    desc: 'Pulizia profonda',
    provider: 'Sofia Bianchi',
    amount: '€95',
    status: 'paid'
  }, {
    id: 5,
    date: '03 Feb 2026',
    desc: 'Cambio biancheria',
    provider: 'Francesca N.',
    amount: '€55',
    status: 'paid'
  }];
  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'paid':
        return <span className="bg-green-50 text-green-700 px-2.5 py-0.5 rounded-full text-xs font-medium border border-green-100" data-id="element-276">
            Pagato
          </span>;
      case 'processing':
        return <span className="bg-amber-50 text-amber-700 px-2.5 py-0.5 rounded-full text-xs font-medium border border-amber-100" data-id="element-277">
            In Elaborazione
          </span>;
      default:
        return null;
    }
  };
  return <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-278">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-279">
        <div data-id="element-280">
          <h1 className="text-xl lg:text-2xl font-bold font-montserrat text-navy mb-1" data-id="element-281">
            Fatturazione
          </h1>
          <p className="text-sm text-gray-500" data-id="element-282">
            Gestisci i pagamenti e visualizza lo storico delle transazioni
          </p>
        </div>
        <div className="flex items-center gap-3" data-id="element-283">
          <button className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-lg text-sm text-navy hover:bg-gray-50 transition-colors" data-id="element-284">
            <Clock size={16} className="text-gray-500" data-id="element-285" />
            <span data-id="element-286">Febbraio 2026</span>
            <ChevronDown size={16} className="text-gray-400" data-id="element-287" />
          </button>
          <button className="p-2 bg-white border border-gray-200 rounded-lg text-gray-500 hover:text-navy hover:bg-gray-50 transition-colors" data-id="element-288">
            <Download size={18} data-id="element-289" />
          </button>
        </div>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-290">
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm" data-id="element-291">
          <div className="flex justify-between items-start mb-2" data-id="element-292">
            <span className="text-xs text-gray-400 uppercase tracking-wider font-medium" data-id="element-293">
              Spese Totale Mese
            </span>
            <div className="p-1.5 bg-navy/5 rounded-lg" data-id="element-294">
              <Euro className="w-4 h-4 text-navy" data-id="element-295" />
            </div>
          </div>
          <div className="flex items-end gap-2" data-id="element-296">
            <span className="text-2xl font-bold text-navy" data-id="element-297">€1.240</span>
          </div>
        </div>

        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm" data-id="element-298">
          <div className="flex justify-between items-start mb-2" data-id="element-299">
            <span className="text-xs text-gray-400 uppercase tracking-wider font-medium" data-id="element-300">
              Prossimo Pagamento
            </span>
            <div className="p-1.5 bg-amber-50 rounded-lg" data-id="element-301">
              <Clock className="w-4 h-4 text-amber-600" data-id="element-302" />
            </div>
          </div>
          <div className="flex items-end gap-2" data-id="element-303">
            <span className="text-2xl font-bold text-navy" data-id="element-304">€340</span>
            <span className="text-xs text-gray-400 mb-1.5" data-id="element-305">
              in scadenza il 15 Feb
            </span>
          </div>
        </div>

        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm" data-id="element-306">
          <div className="flex justify-between items-start mb-2" data-id="element-307">
            <span className="text-xs text-gray-400 uppercase tracking-wider font-medium" data-id="element-308">
              Interventi Completati
            </span>
            <div className="p-1.5 bg-green-50 rounded-lg" data-id="element-309">
              <CheckCircle className="w-4 h-4 text-green-600" data-id="element-310" />
            </div>
          </div>
          <div className="flex items-end gap-2" data-id="element-311">
            <span className="text-2xl font-bold text-navy" data-id="element-312">18</span>
            <span className="text-xs text-gray-400 mb-1.5" data-id="element-313">questo mese</span>
          </div>
        </div>
      </div>

      {/* Payment Method */}
      <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-314">
        <div className="flex items-center gap-4" data-id="element-315">
          <div className="w-12 h-12 bg-gray-50 rounded-full flex items-center justify-center text-gray-600 border border-gray-100" data-id="element-316">
            <CreditCard size={20} data-id="element-317" />
          </div>
          <div data-id="element-318">
            <h3 className="text-sm font-bold text-navy" data-id="element-319">Metodo di Pagamento</h3>
            <p className="text-sm text-gray-500 font-mono" data-id="element-320">
              IT89 •••• •••• 4521
            </p>
          </div>
        </div>
        <button onClick={() => alert('Modifica metodo di pagamento')} className="text-xs font-medium text-teal-deep hover:text-teal-800 transition-colors px-4 py-2 rounded-lg hover:bg-teal-50" data-id="element-321">
          Modifica
        </button>
      </div>

      {/* Transactions Table */}
      <div className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm" data-id="element-322">
        <div className="p-5 border-b border-gray-200 flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-323">
          <h3 className="font-semibold text-navy" data-id="element-324">Transazioni Recenti</h3>
          <div className="flex gap-2" data-id="element-325">
            <button className="flex items-center gap-2 px-3 py-1.5 border border-gray-200 rounded-lg text-xs font-medium text-gray-600 hover:bg-gray-50" data-id="element-326">
              <Filter size={14} data-id="element-327" /> Filtra
            </button>
            <button className="flex items-center gap-2 px-3 py-1.5 border border-gray-200 rounded-lg text-xs font-medium text-gray-600 hover:bg-gray-50" data-id="element-328">
              <Download size={14} data-id="element-329" /> Export CSV
            </button>
          </div>
        </div>

        <div className="overflow-x-auto" data-id="element-330">
          <table className="w-full text-sm text-left" data-id="element-331">
            <thead className="bg-gray-50 text-gray-500 font-medium border-b border-gray-200" data-id="element-332">
              <tr data-id="element-333">
                <th className="px-6 py-3 w-32" data-id="element-334">Data</th>
                <th className="px-6 py-3" data-id="element-335">Descrizione</th>
                <th className="px-6 py-3" data-id="element-336">Fornitore</th>
                <th className="px-6 py-3" data-id="element-337">Importo</th>
                <th className="px-6 py-3" data-id="element-338">Stato</th>
                <th className="px-6 py-3 text-right" data-id="element-339">Ricevuta</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-340">
              {transactions.map(tx => <tr key={tx.id} className="hover:bg-gray-50/50 transition-colors" data-id="element-341">
                  <td className="px-6 py-4 text-gray-500" data-id="element-342">{tx.date}</td>
                  <td className="px-6 py-4 font-medium text-navy" data-id="element-343">{tx.desc}</td>
                  <td className="px-6 py-4 text-gray-600" data-id="element-344">{tx.provider}</td>
                  <td className="px-6 py-4 font-bold text-navy" data-id="element-345">{tx.amount}</td>
                  <td className="px-6 py-4" data-id="element-346">{getStatusBadge(tx.status)}</td>
                  <td className="px-6 py-4 text-right" data-id="element-347">
                    <button onClick={() => alert(`Download ricevuta #${tx.id}`)} className="text-gray-400 hover:text-navy transition-colors p-1 hover:bg-gray-100 rounded" data-id="element-348">
                      <Download size={16} data-id="element-349" />
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="p-4 border-t border-gray-200 text-center" data-id="element-350">
          <button onClick={() => alert('Carica altre transazioni')} className="text-sm font-medium text-teal-deep hover:text-teal-700 transition-colors" data-id="element-351">
            Carica altre transazioni
          </button>
        </div>
      </div>
    </div>;
}